import React, { useState, useEffect } from 'react';
import { Breadcrumb, Collapse, Select } from 'antd';
import { DotChartOutlined, HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import ActivitySwitch from 'modules/layoutModule/components/ActivitySwitch/ActivitySwitch';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import {
  Form,
  Input,
  Button,
  Space,
  Skeleton,
  ConfigProvider,
  BackTop,
} from 'antd';
import { FieldData } from 'rc-field-form/lib/interface';
import { useHistory } from 'react-router-dom';
import plPL from 'antd/lib/locale/pl_PL';
import 'moment/locale/pl';
import FormCoverUpload from 'modules/galleryModules/components/FormCoverUpload';
import {
  getFertilizersCategoriesRequest,
  getPackRequest,
  getParametersRequest,
  getPlantsRequest,
} from '../requests/fertilizersRequests';
import {
  getSpecificFertilizerGardenRequest,
  updateFertilizerGardenRequest,
} from '../requests/fertilizersGardenRequests';
import TextEditor from 'modules/layoutModule/components/TextEditor/TextEditor';
import FormFileUpload from 'modules/galleryModules/components/FormFileUpload';
import copyToClipboard from '../../../helpers/copyToClipboard';

const { TextArea } = Input;
const { Panel } = Collapse;

const GardenFertilizersEdit = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const [fields, setFields] = useState<FieldData[]>([]);
  const [loading, toggleLoading] = useState<boolean>(false);
  const history = useHistory();
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [isActivityDisabled, toggleActivityDisable] = useState(false);
  const [fileImage1, setFileImage1] = useState<string | null>(null);
  const [fileImage2, setFileImage2] = useState<string | null>(null);
  const [fileImage3, setFileImage3] = useState<string | null>(null);
  const [fileImage4, setFileImage4] = useState<string | null>(null);
  const [fileImage5, setFileImage5] = useState<string | null>(null);
  const [fileImage6, setFileImage6] = useState<string | null>(null);
  const [fileImage7, setFileImage7] = useState<string | null>(null);
  const [fileImage8, setFileImage8] = useState<string | null>(null);
  const [fileImage9, setFileImage9] = useState<string | null>(null);
  const [fileImage10, setFileImage10] = useState<string | null>(null);
  const [fileImage11, setFileImage11] = useState<string | null>(null);
  const [fileImage12, setFileImage12] = useState<string | null>(null);
  const [fileImage13, setFileImage13] = useState<string | null>(null);
  const [fileImage14, setFileImage14] = useState<string | null>(null);
  const [fileImage15, setFileImage15] = useState<string | null>(null);

  const [fileImage1Changed, changedFileImage1] = useState<boolean>(false);
  const [fileImage2Changed, changedFileImage2] = useState<boolean>(false);
  const [fileImage3Changed, changedFileImage3] = useState<boolean>(false);
  const [fileImage4Changed, changedFileImage4] = useState<boolean>(false);
  const [fileImage5Changed, changedFileImage5] = useState<boolean>(false);
  const [fileImage6Changed, changedFileImage6] = useState<boolean>(false);
  const [fileImage7Changed, changedFileImage7] = useState<boolean>(false);
  const [fileImage8Changed, changedFileImage8] = useState<boolean>(false);
  const [fileImage9Changed, changedFileImage9] = useState<boolean>(false);
  const [fileImage10Changed, changedFileImage10] = useState<boolean>(false);
  const [fileImage11Changed, changedFileImage11] = useState<boolean>(false);
  const [fileImage12Changed, changedFileImage12] = useState<boolean>(false);
  const [fileImage13Changed, changedFileImage13] = useState<boolean>(false);
  const [fileImage14Changed, changedFileImage14] = useState<boolean>(false);
  const [fileImage15Changed, changedFileImage15] = useState<boolean>(false);

  const [categories, setCategories] = useState([]);
  const [parameters, setParameters] = useState([]);
  const [plants, setPlants] = useState([]);
  const [pack, setPack] = useState([]);
  const [packWithEmpty, setPackWithEmpty] = useState([]);

  const [contentValue, setContentValue] = useState<string | undefined>('');
  const [properties, setProperties] = useState<string | undefined>('');
  const [benefits, setBenefits] = useState<string | undefined>('');
  const [howToUse, setHowToUse] = useState<string | undefined>('');
  const [fertilizerPackage, setPackage] = useState<string | undefined>('');
  const [safety, setSafety] = useState<string | undefined>('');

  const [file1, setFile1] = useState<string | null>(null);
  const [file2, setFile2] = useState<string | null>(null);
  const [file3, setFile3] = useState<string | null>(null);
  const [file4, setFile4] = useState<string | null>(null);
  const [file5, setFile5] = useState<string | null>(null);

  const [file1Changed, changedFile1] = useState<boolean>(false);
  const [file2Changed, changedFile2] = useState<boolean>(false);
  const [file3Changed, changedFile3] = useState<boolean>(false);
  const [file4Changed, changedFile4] = useState<boolean>(false);
  const [file5Changed, changedFile5] = useState<boolean>(false);

  const updateFile = (
    e: string,
    field: string,
    coverMethod: (value: string) => void,
    coverMethodChanged: (value: boolean) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
    coverMethodChanged(true);
  };

  useEffect(() => {
    toggleLoading(true);

    getFertilizersCategoriesRequest().then((response) => {
      if (response) {
        const sections = response.data.map(
          (section: { name: string; id: number; subCatName?: string }) => {
            return {
              label: `${section.name} ${section.subCatName ? `/ ${section.subCatName}` : ``
                }`,
              value: section.id,
            };
          }
        );
        setCategories(sections);
      }
    });

    getPackRequest().then((response) => {
      if (response) {
        // @ts-ignore
        const onlyActivePacks = response.data.filter((pack) => pack.isActive);
        const sections = onlyActivePacks.map((section: any) => {
          return {
            label: section.name,
            value: section.id,
          };
        });
        setPack(sections);
        const sectionsWithEmpty = [...sections];
        sectionsWithEmpty.unshift({ label: '', value: '' });
        // @ts-ignore
        setPackWithEmpty(sectionsWithEmpty);
      }
    });

    getParametersRequest().then((response) => {
      if (response) {
        const sections = response.map((section: any) => {
          return {
            label: section.name,
            value: section.id,
          };
        });
        sections.unshift({ label: '', value: '' });
        setParameters(sections);
      }
    });

    getPlantsRequest().then((response) => {
      if (response) {
        const sections = response.map(
          (section: { name: string; id: number }) => {
            return {
              label: section.name,
              value: section.id,
            };
          }
        );
        sections.unshift({ label: '', value: '' });
        setPlants(sections);
      }
    });

    getSpecificFertilizerGardenRequest(id)
      .then((response) => {
        if (response) {
          toggleLoading(false);
          const { data } = response;
          setFields([
            {
              name: ['id'],
              value: data.id,
            },
            {
              name: ['name'],
              value: data.name,
            },
            {
              name: ['name2'],
              value: data.name2,
            },
            {
              name: ['use'],
              value: data.fertilizerUse,
            },
            {
              name: ['chemicalFormula'],
              value: data.chemicalFormula,
            },
            {
              name: ['sortOrder'],
              value: data.sortOrder,
            },
            {
              name: ['parameters'],
              value: data.parameters,
            },
            {
              name: ['category'],
              value: data.category,
            },
            {
              name: ['description'],
              value: data.description,
            },
            {
              name: ['productPackIcon1'],
              value: data.productPackIcon1,
            },
            {
              name: ['productPackIcon2'],
              value: data.productPackIcon2,
            },
            {
              name: ['productPackIcon3'],
              value: data.productPackIcon3,
            },
            {
              name: ['productPackIcon4'],
              value: data.productPackIcon4,
            },
            {
              name: ['productPackIcon5'],
              value: data.productPackIcon5,
            },
            {
              name: ['productPackIcon6'],
              value: data.productPackIcon6,
            },
            {
              name: ['table1'],
              value: data.table1,
            },
            {
              name: ['table2'],
              value: data.table2,
            },
            {
              name: ['table3'],
              value: data.table3,
            },
            {
              name: ['table4'],
              value: data.table4,
            },
            {
              name: ['table5'],
              value: data.table5,
            },
            {
              name: ['table6'],
              value: data.table6,
            },
            {
              name: ['table7'],
              value: data.table7,
            },
            {
              name: ['table8'],
              value: data.table8,
            },
            {
              name: ['table9'],
              value: data.table9,
            },
            {
              name: ['table10'],
              value: data.table10,
            },
            {
              name: ['additionalPictogram1'],
              value: data.additionalPictogram1,
            },
            {
              name: ['additionalPictogram2'],
              value: data.additionalPictogram2,
            },
            {
              name: ['additionalPictogram3'],
              value: data.additionalPictogram3,
            },
            {
              name: ['additionalPictogram4'],
              value: data.additionalPictogram4,
            },
            {
              name: ['additionalPictogram5'],
              value: data.additionalPictogram5,
            },
            {
              name: ['additionalPictogram6'],
              value: data.additionalPictogram6,
            },
            {
              name: ['plantsUse1'],
              value: data.plantsUse1,
            },
            {
              name: ['plantsUse2'],
              value: data.plantsUse2,
            },
            {
              name: ['plantsUse3'],
              value: data.plantsUse3,
            },
            {
              name: ['plantsUse4'],
              value: data.plantsUse4,
            },
            {
              name: ['plantsUse5'],
              value: data.plantsUse5,
            },
            {
              name: ['nameUploadedFile1'],
              value: data.nameUploadedFile1,
            },
            {
              name: ['nameUploadedFile2'],
              value: data.nameUploadedFile2,
            },
            {
              name: ['nameUploadedFile3'],
              value: data.nameUploadedFile3,
            },
            {
              name: ['nameUploadedFile4'],
              value: data.nameUploadedFile4,
            },
            {
              name: ['nameUploadedFile5'],
              value: data.nameUploadedFile5,
            },
            {
              name: ['fileImage1'],
              value: data.image1,
            },
            {
              name: ['fileImage2'],
              value: data.image2,
            },
            {
              name: ['fileImage3'],
              value: data.image3,
            },
            {
              name: ['fileImage4'],
              value: data.picto_ce,
            },
            {
              name: ['uploadFilePictogram1'],
              value: data.uploadFilePictogram1,
            },
            {
              name: ['uploadFilePictogram2'],
              value: data.uploadFilePictogram2,
            },
            {
              name: ['uploadFilePictogram3'],
              value: data.uploadFilePictogram3,
            },
            {
              name: ['uploadFilePictogram4'],
              value: data.uploadFilePictogram4,
            },
            {
              name: ['uploadFilePictogram5'],
              value: data.uploadFilePictogram5,
            },
            {
              name: ['fileImage10'],
              value: data.uploadFilePictogram6,
            },
            {
              name: ['fileImage11'],
              value: data.fileImage1,
            },
            {
              name: ['fileImage12'],
              value: data.fileImage2,
            },
            {
              name: ['fileImage13'],
              value: data.fileImage3,
            },
            {
              name: ['fileImage14'],
              value: data.fileImage4,
            },
            {
              name: ['fileImage15'],
              value: data.fileImage5,
            },
            {
              name: ['isActive'],
              value: data.isActive || false,
            },
          ]);

          form.setFieldsValue({
            fileImage1: data?.image1,
            fileImage2: data?.image2,
            fileImage3: data?.image3,
            fileImage4: data?.picto_ce,
            uploadFilePictogram1: data?.uploadFilePictogram1,
            uploadFilePictogram2: data?.uploadFilePictogram2,
            uploadFilePictogram3: data?.uploadFilePictogram3,
            uploadFilePictogram4: data?.uploadFilePictogram4,
            uploadFilePictogram5: data?.uploadFilePictogram5,
            uploadFilePictogram6: data?.uploadFilePictogram6,
            fileImage11: data?.fileImage1,
            fileImage12: data?.fileImage2,
            fileImage13: data?.fileImage3,
            fileImage14: data?.fileImage4,
            fileImage15: data?.fileImage5,
            uploadedFile1: data?.uploadedFile1,
            uploadedFile2: data?.uploadedFile2,
            uploadedFile3: data?.uploadedFile3,
            uploadedFile4: data?.uploadedFile4,
            uploadedFile5: data?.uploadedFile5,
          });

          setFileImage1(data?.image1);
          setFileImage2(data?.image2);
          setFileImage3(data?.image3);

          if (data?.picto_ce) {
            const qualityMarkSrc = data?.picto_ce?.includes('nawozy/') || data?.picto_ce?.includes('nawozyGarden/')
              ? data?.picto_ce
              : `quality_mark/${data?.picto_ce}`;
            setFileImage4(qualityMarkSrc);
          }

setFileImage5(data?.uploadFilePictogram1);
          setFileImage6(data?.uploadFilePictogram2);
          setFileImage7(data?.uploadFilePictogram3);
          setFileImage8(data?.uploadFilePictogram4);
          setFileImage9(data?.uploadFilePictogram5);
          setFileImage10(data?.uploadFilePictogram6);
          setFileImage11(data?.fileImage1);
          setFileImage12(data?.fileImage2);
          setFileImage13(data?.fileImage3);
          setFileImage14(data?.fileImage4);
          setFileImage15(data?.fileImage5);

          setFile1(data?.uploadedFile1);
          setFile2(data?.uploadedFile2);
          setFile3(data?.uploadedFile3);
          setFile4(data?.uploadedFile4);
          setFile5(data?.uploadedFile5);

          setContentValue(data.description);
          setProperties(data.properties);
          setBenefits(data.benefits);
          setHowToUse(data.howToUse);
          setPackage(data.package);
          setSafety(data.safety);

          if (data.activitySwitchDisabled) {
            toggleActivityDisable(true);
          }
        } else {
          history.push('/garden/fertilizers');
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  const onFinish = (values: any) => {
    toggleButtonLoading(true);
    updateFertilizerGardenRequest(values).then(() => {
      toggleButtonLoading(false);
    });
  };

  const onContentEdit = (e: any, field: string) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
  };

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  const updateCover = (
    e: string,
    field: string,
    coverMethod: (value: string) => void,
    coverMethodChanged: (value: boolean) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
    coverMethodChanged(true);
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Nawozy GARDEN</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/garden/fertilizers">Lista</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/garden/fertilizers/${id}`}>Edycja wpisu</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <ConfigProvider locale={plPL}>
        <div className="site-layout-background">
          {loading && <Skeleton active />}
          {!loading && (
            <Form
              layout="vertical"
              fields={fields}
              onFinish={onFinish}
              form={form}
              validateMessages={validateMessages}
            >
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Form.Item
                name="category"
                label="Kategoria / Podkategoria"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Wybierz kategorię"
                  optionFilterProp="children"
                  options={categories}
                  filterOption={(input, option) => {
                    // @ts-ignore
                    if (option?.label) {
                      // @ts-ignore
                      return option.label
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Form.Item>
              <Form.Item
                name="parameters"
                label="Połącz z parametrami do porównywarki"
              >
                <Select
                  showSearch
                  placeholder="Wybierz parametry"
                  optionFilterProp="children"
                  options={parameters}
                  filterOption={(input, option) => {
                    // @ts-ignore
                    if (option?.label) {
                      // @ts-ignore
                      return option.label
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Form.Item>
              <Form.Item
                name="name"
                label="Nazwa w sliderze"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="name2"
                label="Nazwa na podstronie produktu"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item name="chemicalFormula" label="Formuła nawozu">
                <Input />
              </Form.Item>
              <Form.Item name="fileImage4" label="Piktogram pod formułą nawozu">
                <FormCoverUpload
                  cover={fileImage4}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage4',
                      setFileImage4,
                      changedFileImage4
                    )
                  }
                  isNew={fileImage4Changed}
                  id={form.getFieldsValue()?.id}
                  field="fileImage4"
                  number={4}
                  hideTags
                  originalFile
                />
              </Form.Item>
              <Form.Item
                name="fileImage1"
                label="Opakowanie główne PNG"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <FormCoverUpload
                  cover={fileImage1}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage1',
                      setFileImage1,
                      changedFileImage1
                    )
                  }
                  isNew={fileImage1Changed}
                  id={form.getFieldsValue()?.id}
                  field="fileImage1"
                  number={1}
                  hideTags
                  asPng
                />
              </Form.Item>
              <Form.Item name="fileImage2" label="Opakowanie dodatkowe 1 PNG">
                <FormCoverUpload
                  cover={fileImage2}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage2',
                      setFileImage2,
                      changedFileImage2
                    )
                  }
                  isNew={fileImage2Changed}
                  id={form.getFieldsValue()?.id}
                  field="fileImage2"
                  number={2}
                  hideTags
                  asPng
                />
              </Form.Item>
              <Form.Item name="fileImage3" label="Opakowanie dodatkowe 2 PNG">
                <FormCoverUpload
                  cover={fileImage3}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage3',
                      setFileImage3,
                      changedFileImage3
                    )
                  }
                  isNew={fileImage3Changed}
                  id={form.getFieldsValue()?.id}
                  field="fileImage3"
                  number={3}
                  hideTags
                  asPng
                />
              </Form.Item>
              <Form.Item
                name="productPackIcon1"
                label="Piktogram opakowania 1"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Wybierz productPackIcon"
                  optionFilterProp="children"
                  options={pack}
                  filterOption={(input, option) => {
                    // @ts-ignore
                    if (option?.label) {
                      // @ts-ignore
                      return option.label
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Form.Item>
              <Form.Item name="productPackIcon2" label="Piktogram opakowania 2">
                <Select
                  showSearch
                  placeholder="Wybierz productPackIcon"
                  optionFilterProp="children"
                  options={packWithEmpty}
                  filterOption={(input, option) => {
                    // @ts-ignore
                    if (option?.label) {
                      // @ts-ignore
                      return option.label
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Form.Item>
              <Form.Item name="productPackIcon3" label="Piktogram opakowania 3">
                <Select
                  showSearch
                  placeholder="Wybierz productPackIcon"
                  optionFilterProp="children"
                  options={packWithEmpty}
                  filterOption={(input, option) => {
                    // @ts-ignore
                    if (option?.label) {
                      // @ts-ignore
                      return option.label
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Form.Item>
              <Form.Item name="productPackIcon4" label="Piktogram opakowania 4">
                <Select
                  showSearch
                  placeholder="Wybierz productPackIcon"
                  optionFilterProp="children"
                  options={packWithEmpty}
                  filterOption={(input, option) => {
                    // @ts-ignore
                    if (option?.label) {
                      // @ts-ignore
                      return option.label
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Form.Item>
              <Form.Item name="productPackIcon5" label="Piktogram opakowania 5">
                <Select
                  showSearch
                  placeholder="Wybierz productPackIcon"
                  optionFilterProp="children"
                  options={packWithEmpty}
                  filterOption={(input, option) => {
                    // @ts-ignore
                    if (option?.label) {
                      // @ts-ignore
                      return option.label
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Form.Item>
              <Form.Item name="productPackIcon6" label="Piktogram opakowania 6">
                <Select
                  showSearch
                  placeholder="Wybierz productPackIcon"
                  optionFilterProp="children"
                  options={packWithEmpty}
                  filterOption={(input, option) => {
                    // @ts-ignore
                    if (option?.label) {
                      // @ts-ignore
                      return option.label
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Form.Item>
              <Form.Item
                name="description"
                label="Podstawowe informacje"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                {/* @ts-ignore */}
                <TextEditor
                  initialValue={contentValue}
                  onChange={(e) => onContentEdit(e, 'description')}
                  disableGallery
                />
              </Form.Item>
              <Form.Item name="properties" label="Właściwości i skład">
                {/* @ts-ignore */}
                <TextEditor
                  initialValue={properties}
                  onChange={(e) => onContentEdit(e, 'properties')}
                  disableGallery
                />
              </Form.Item>
              <Form.Item name="benefits" label="Korzyści ze stosowania">
                {/* @ts-ignore */}
                <TextEditor
                  initialValue={benefits}
                  onChange={(e) => onContentEdit(e, 'benefits')}
                  disableGallery
                />
              </Form.Item>
              <Form.Item name="howToUse" label="Przeznaczenie i stosowanie">
                {/* @ts-ignore */}
                <TextEditor
                  initialValue={howToUse}
                  onChange={(e) => onContentEdit(e, 'howToUse')}
                  disableGallery
                />
              </Form.Item>
              <Form.Item
                name="use"
                label="Nazwa tytułu powiązanych upraw nawożenia"
              >
                <Input />
              </Form.Item>
              <Form.Item name="plantsUse1" label="Połącz z nawożeniem uprawy 1">
                <Select
                  showSearch
                  placeholder="Wybierz plantsUse"
                  optionFilterProp="children"
                  options={plants}
                  filterOption={(input, option) => {
                    // @ts-ignore
                    if (option?.label) {
                      // @ts-ignore
                      return option.label
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Form.Item>
              <Form.Item name="plantsUse2" label="Połącz z nawożeniem uprawy 2">
                <Select
                  showSearch
                  placeholder="Wybierz plantsUse"
                  optionFilterProp="children"
                  options={plants}
                  filterOption={(input, option) => {
                    // @ts-ignore
                    if (option?.label) {
                      // @ts-ignore
                      return option.label
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Form.Item>
              <Form.Item name="plantsUse3" label="Połącz z nawożeniem uprawy 3">
                <Select
                  showSearch
                  placeholder="Wybierz plantsUse"
                  optionFilterProp="children"
                  options={plants}
                  filterOption={(input, option) => {
                    // @ts-ignore
                    if (option?.label) {
                      // @ts-ignore
                      return option.label
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Form.Item>
              <Form.Item name="plantsUse4" label="Połącz z nawożeniem uprawy 4">
                <Select
                  showSearch
                  placeholder="Wybierz plantsUse"
                  optionFilterProp="children"
                  options={plants}
                  filterOption={(input, option) => {
                    // @ts-ignore
                    if (option?.label) {
                      // @ts-ignore
                      return option.label
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Form.Item>
              <Form.Item name="plantsUse5" label="Połącz z nawożeniem uprawy 5">
                <Select
                  showSearch
                  placeholder="Wybierz plantsUse"
                  optionFilterProp="children"
                  options={plants}
                  filterOption={(input, option) => {
                    // @ts-ignore
                    if (option?.label) {
                      // @ts-ignore
                      return option.label
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Form.Item>
              <Form.Item
                name="package"
                label="Informacje uzupełniające / Pakowanie, transport i przechowywanie"
              >
                {/* @ts-ignore */}
                <TextEditor
                  initialValue={fertilizerPackage}
                  onChange={(e) => onContentEdit(e, 'package')}
                  disableGallery
                />
              </Form.Item>
              <Form.Item
                name="additionalPictogram1"
                label="Przechowywanie w opakowaniu 1"
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="uploadFilePictogram1"
                label="Piktogramy przechowywania 1"
              >
                <FormCoverUpload
                  cover={fileImage5}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'uploadFilePictogram1',
                      setFileImage5,
                      changedFileImage5
                    )
                  }
                  isNew={fileImage5Changed}
                  field="uploadFilePictogram1"
                  number={5}
                  hideTags
                  originalFile
                />
              </Form.Item>
              <Form.Item
                name="additionalPictogram2"
                label="Przechowywanie w opakowaniu 2"
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="uploadFilePictogram2"
                label="Piktogramy przechowywania 2"
              >
                <FormCoverUpload
                  cover={fileImage6}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'uploadFilePictogram2',
                      setFileImage6,
                      changedFileImage6
                    )
                  }
                  isNew={fileImage6Changed}
                  field="uploadFilePictogram2"
                  number={6}
                  hideTags
                  originalFile
                />
              </Form.Item>
              <Form.Item
                name="additionalPictogram3"
                label="Przechowywanie w opakowaniu 3"
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="uploadFilePictogram3"
                label="Piktogramy przechowywania 3"
              >
                <FormCoverUpload
                  cover={fileImage7}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'uploadFilePictogram3',
                      setFileImage7,
                      changedFileImage7
                    )
                  }
                  isNew={fileImage7Changed}
                  field="uploadFilePictogram3"
                  number={7}
                  hideTags
                  originalFile
                />
              </Form.Item>
              <Form.Item
                name="additionalPictogram4"
                label="Przechowywanie w opakowaniu 4"
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="uploadFilePictogram4"
                label="Piktogramy przechowywania 4"
              >
                <FormCoverUpload
                  cover={fileImage8}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'uploadFilePictogram4',
                      setFileImage8,
                      changedFileImage8
                    )
                  }
                  isNew={fileImage8Changed}
                  field="uploadFilePictogram4"
                  number={8}
                  hideTags
                  originalFile
                />
              </Form.Item>
              <Form.Item
                name="additionalPictogram5"
                label="Przechowywanie w opakowaniu 5"
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="uploadFilePictogram5"
                label="Piktogramy przechowywania 5"
              >
                <FormCoverUpload
                  cover={fileImage9}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'uploadFilePictogram5',
                      setFileImage9,
                      changedFileImage9
                    )
                  }
                  isNew={fileImage9Changed}
                  field="uploadFilePictogram5"
                  number={9}
                  hideTags
                  originalFile
                />
              </Form.Item>
              <Form.Item
                name="additionalPictogram6"
                label="Przechowywanie w opakowaniu 6"
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="uploadFilePictogram6"
                label="Piktogramy przechowywania 6"
              >
                <FormCoverUpload
                  cover={fileImage10}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'uploadFilePictogram6',
                      setFileImage10,
                      changedFileImage10
                    )
                  }
                  isNew={fileImage10Changed}
                  field="uploadFilePictogram6"
                  number={10}
                  hideTags
                  originalFile
                />
              </Form.Item>
              <Form.Item
                name="safety"
                label="Informacje uzupełniające / Środki ostrożności"
              >
                {/* @ts-ignore */}
                <TextEditor
                  initialValue={safety}
                  onChange={(e) => onContentEdit(e, 'safety')}
                  disableGallery
                />
              </Form.Item>
              <br />
              Informacje uzupełniające / Pliki do pobrania
              <Form.Item
                name="nameUploadedFile1"
                label="Nazwa pliku do pobrania 1"
              >
                <Input />
              </Form.Item>
              <Form.Item name="uploadedFile1" label="Plik do pobrania 1 PDF">
                <FormFileUpload
                  file={file1}
                  setFile={(e) => updateFile(e, 'uploadedFile1', setFile1, changedFile1)}
                  isNew={file1Changed}
                  field="file1"
                />
              </Form.Item>
              <Form.Item
                name="nameUploadedFile2"
                label="Nazwa pliku do pobrania 2"
              >
                <Input />
              </Form.Item>
              <Form.Item name="uploadedFile2" label="Plik do pobrania 2 PDF">
                <FormFileUpload
                  file={file2}
                  setFile={(e) => updateFile(e, 'uploadedFile2', setFile2, changedFile2)}
                  isNew={file2Changed}
                  field="file2"
                />
              </Form.Item>
              <Form.Item
                name="nameUploadedFile3"
                label="Nazwa pliku do pobrania 3"
              >
                <Input />
              </Form.Item>
              <Form.Item name="uploadedFile3" label="Plik do pobrania 3 PDF">
                <FormFileUpload
                  file={file3}
                  setFile={(e) => updateFile(e, 'uploadedFile3', setFile3, changedFile3)}
                  isNew={file3Changed}
                  field="file3"
                />
              </Form.Item>
              <Form.Item
                name="nameUploadedFile4"
                label="Nazwa pliku do pobrania 4"
              >
                <Input />
              </Form.Item>
              <Form.Item name="uploadedFile4" label="Plik do pobrania 4 PDF">
                <FormFileUpload
                  file={file4}
                  setFile={(e) => updateFile(e, 'uploadedFile4', setFile4, changedFile4)}
                  isNew={file4Changed}
                  field="file4"
                />
              </Form.Item>
              <Form.Item
                name="nameUploadedFile5"
                label="Nazwa pliku do pobrania 5"
              >
                <Input />
              </Form.Item>
              <Form.Item name="uploadedFile5" label="Plik do pobrania 5 PDF">
                <FormFileUpload
                  file={file5}
                  setFile={(e) => updateFile(e, 'uploadedFile5', setFile5, changedFile5)}
                  isNew={file5Changed}
                  field="file5"
                />
              </Form.Item>
              <br />
              Galeria
              <Form.Item name="fileImage11" label="Plik galerii 1">
                <FormCoverUpload
                  cover={fileImage11}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage11',
                      setFileImage11,
                      changedFileImage11
                    )
                  }
                  isNew={fileImage11Changed}
                  id={form.getFieldsValue()?.id}
                  field="fileImage11"
                  number={11}
                  hideTags
                />
              </Form.Item>
              <Form.Item name="fileImage12" label="Plik galerii 2">
                <FormCoverUpload
                  cover={fileImage12}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage12',
                      setFileImage12,
                      changedFileImage12
                    )
                  }
                  isNew={fileImage12Changed}
                  id={form.getFieldsValue()?.id}
                  field="fileImage12"
                  number={12}
                  hideTags
                />
              </Form.Item>
              <Form.Item name="fileImage13" label="Plik galerii 3">
                <FormCoverUpload
                  cover={fileImage13}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage13',
                      setFileImage13,
                      changedFileImage13
                    )
                  }
                  isNew={fileImage13Changed}
                  id={form.getFieldsValue()?.id}
                  field="fileImage13"
                  number={13}
                  hideTags
                />
              </Form.Item>
              <Form.Item name="fileImage14" label="Plik galerii 4">
                <FormCoverUpload
                  cover={fileImage14}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage14',
                      setFileImage14,
                      changedFileImage14
                    )
                  }
                  isNew={fileImage14Changed}
                  id={form.getFieldsValue()?.id}
                  field="fileImage14"
                  number={14}
                  hideTags
                />
              </Form.Item>
              <Form.Item name="fileImage15" label="Plik galerii 5">
                <FormCoverUpload
                  cover={fileImage15}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage15',
                      setFileImage15,
                      changedFileImage15
                    )
                  }
                  isNew={fileImage15Changed}
                  id={form.getFieldsValue()?.id}
                  field="fileImage15"
                  number={15}
                  hideTags
                />
              </Form.Item>
              <br />
              <div className="tables-collapse">
                <Collapse defaultActiveKey={[]}>
                  <Panel header="Tabelka 1" key="1" forceRender>
                    <Form.Item name="table1" label="Tabelka 1">
                      <Input.TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#1')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#1
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 2" key="2" forceRender>
                    <Form.Item name="table2" label="Tabelka 2">
                      <Input.TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#2')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#2
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 3" key="3" forceRender>
                    <Form.Item name="table3" label="Tabelka 3">
                      <Input.TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#3')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#3
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 4" key="4" forceRender>
                    <Form.Item name="table4" label="Tabelka 4">
                      <Input.TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#4')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#4
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 5" key="5" forceRender>
                    <Form.Item name="table5" label="Tabelka 5">
                      <Input.TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#5')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#5
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 6" key="6" forceRender>
                    <Form.Item name="table6" label="Tabelka 6">
                      <Input.TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#6')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#6
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 7" key="7" forceRender>
                    <Form.Item name="table7" label="Tabelka 7">
                      <Input.TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#7')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#7
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 8" key="8" forceRender>
                    <Form.Item name="table8" label="Tabelka 8">
                      <Input.TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#8')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#8
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 9" key="9" forceRender>
                    <Form.Item name="table9" label="Tabelka 9">
                      <Input.TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#9')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#9
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 10" key="10" forceRender>
                    <Form.Item name="table10" label="Tabelka 10">
                      <Input.TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#10')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#10
                    </Button>
                  </Panel>
                </Collapse>
              </div>
              <Form.Item
                name="sortOrder"
                label="Kolejność"
                rules={[
                  {
                    required: true,
                  },
                  {
                    validator: async (_, value) => {
                      if (value) {
                        if (
                          (value.length > 5 ||
                            !/^[0-9]*\,?\.?[0-9]*$/.test(value)) &&
                          value.length > 0
                        ) {
                          return Promise.reject(
                            new Error('Proszę podać poprawną wartość!')
                          );
                        }
                      }
                    },
                  },
                ]}
              >
                <Input
                  style={{
                    width: '100px',
                  }}
                />
              </Form.Item>
              <ActivitySwitch isActivityDisabled={isActivityDisabled} />
              <Form.Item>
                <Space>
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={<SaveOutlined />}
                    loading={isSaveButtonLoading}
                  >
                    Zapisz
                  </Button>
                  <Link to="/garden/fertilizers">
                    <Button>Powrót</Button>
                  </Link>
                </Space>
              </Form.Item>
            </Form>
          )}
          {loading && (
            <Link to="/garden/fertilizers">
              <Button>Powrót</Button>
            </Link>
          )}
          <BackTop />
        </div>
      </ConfigProvider>
    </>
  );
};

export default GardenFertilizersEdit;
